import { Input, Text } from '../../styledComponents';
import styles from './FormGroup.module.css';

type FormGroupProps = {
  id?: string;
  label: string;
  type: string;
  placeholder: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  name?: string;
  errorText?: string;
  displayAsTextArea?: boolean;
  icon?: JSX.Element;
  required?: boolean;
  disabled?: boolean;
  leftLabel?: string;
  autoFocus?: boolean;
  rightLabel?: string;
};

export default function FormGroup({
  id,
  label,
  type = 'text',
  placeholder,
  value,
  onChange,
  name,
  errorText,
  displayAsTextArea = false,
  icon,
  required = false,
  disabled = false,
  leftLabel = '',
  autoFocus = false,
  rightLabel = '',
}: FormGroupProps) {
  return (
    <div className={styles.formGroup}>
      <div className={styles.labelContainer}>
        <label htmlFor={id}>
          {icon && icon}
          {label}
          {required && ' *'}
        </label>
        <span>{rightLabel}</span>
      </div>
      <div className={styles.inputContainer}>
        {leftLabel && <span className={styles.leftLabel}>{leftLabel}</span>}
        {displayAsTextArea ? (
          <Input
            as="textarea"
            height={200}
            id={id}
            placeholder={placeholder}
            name={name}
            value={value}
            onChange={onChange}
            fontSize="14px"
            style={{ borderColor: errorText ? '#e64848' : '#e2e2e2' }}
            required={required}
            disabled={disabled}
            autoFocus={autoFocus}
          />
        ) : (
          <Input
            id={id}
            type={type}
            placeholder={placeholder}
            name={name}
            value={value}
            onChange={onChange}
            fontSize="14px"
            style={{ borderColor: errorText ? '#e64848' : '#e2e2e2' }}
            required={required}
            disabled={disabled}
            autoFocus={autoFocus}
          />
        )}
      </div>
      <Text color="#e64848" fontSize="14px">
        {errorText}
      </Text>
    </div>
  );
}
